export const getBrandId = state => state.global.brandId;
export const getBrandDetails = state => state.global.brand;
export const getLanguage = state => state.i18nState.lang;
export const getCurrency = state => state.currency.currency;
